import { Typography } from "@mui/material";
import { formatPrice } from "Components/Merchant/Initiate/InitiatePaymentKeypad/utils";
import type { CurrencyCode } from "Models/CurrencyCodes";

type Props = {
  priceInCents: number;
  currencyCode: CurrencyCode | undefined;
};

export const CurrentItemPrice = ({ priceInCents, currencyCode }: Props) => (
  <Typography variant="h2" textAlign="center">
    {formatPrice(priceInCents, currencyCode)}
  </Typography>
);
